<template>
  <section class="video-section">
    <h2>Our Pre-Wedding Video</h2>

    <!-- Option 1: Google Drive's built-in player -->
    <iframe
      src="https://drive.google.com/file/d/1bHLnmOQsAKjKKjigRfc_JUoamh-oAkpF/preview"
      width="80%"
      height="230"
      allow="autoplay"
      frameborder="0"
    ></iframe>

    <!-- Option 2: Native HTML5 video player -->
    <!--
    <video width="640" height="360" controls>
      <source src="https://drive.google.com/uc?export=download&id=1bHLnmOQsAKjKKjigRfc_JUoamh-oAkpF" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    -->
  </section>
</template>

<script>
export default {
  name: "VideoSection",
};
</script>

<style scoped>
.video-section {
  text-align: center;
  margin: 2rem 0;
}
.video-section h2 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
}
iframe, video {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}
</style>
